import {Routes} from "@angular/router";
import {LoginGuard} from "../../shared/authguards/login.guard";
import {LeaveFormGuard} from "../../shared/authguards/leave-form.guard";

export const GLOBAL_CONTENT_ROUTES: Routes = [
  {
    path: "",
    loadComponent: () => import("./global-content.component").then(m => m.GlobalContentComponent),
    canActivate: [LoginGuard],
    children: [
      {
        path: "emo",
        loadComponent: () => import("./emo/emo.component").then(m => m.EmoComponent),
        data: { title: "pageTitles.emo" },
      },
      {
        path: "video-guides",
        loadComponent: () => import("./video-guides/video-guides.component").then(m => m.VideoGuidesComponent),
        data: { title: "pageTitles.videos" },
      },
      {
        path: "practitioners",
        loadComponent: () => import("./practitioners/practitioners.component").then(m => m.PractitionersComponent),
        data: { title: "pageTitles.practitioners" },
      },
      {
        path: "terms",
        loadComponent: () => import("./terms/terms.component").then(m => m.TermsComponent),
        data: { title: "pageTitles.terms" },
        canDeactivate:[LeaveFormGuard]
      },
      {
        path: "privacy",
        loadComponent: () => import("./terms/terms.component").then(m => m.TermsComponent),
        data: { title: "pageTitles.privacy" },
        canDeactivate:[LeaveFormGuard]
      },
      {
        path: "price-list",
        loadComponent: () => import("./price-list/price-list.component").then(m => m.PriceListComponent),
        data: { title: "pageTitles.priceList" },
        canDeactivate:[LeaveFormGuard]
      },
    ],
  },
];
